import script from "./SectionEConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionEConsent.vue?vue&type=script&setup=true&lang=js"

import "./SectionEConsent.vue?vue&type=style&index=0&id=c63c93d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c63c93d4"]])

export default __exports__